import angular from 'angular';
import { MeurhContribuintesIndividuaisService } from './contribuintesindividuais.service';

export const MeurhContribuintesIndividuaisListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhContribuintesIndividuaisService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhContribuintesIndividuaisService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        temPermissao: (arg: string) => boolean,
                        liberadoTela: (arg: string) => boolean,
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (
                        !$rootScope.temPermissao('visualizar_contribuinte') ||
                        !$rootScope.liberadoTela('LIBERAR_SOLICITACAO_CONTRATACAO_CONTRIBUINTE')
                    ) {
                        return $q<void>(() => $state.go('dp'));
                    }

                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_contribuintesindividuais'));
                    }

                    return entityService.getContratacaoContribuinte($stateParams['solicitacao'])
                        .then((data) => {
                            const deveRedirecionar = data.estabelecimento.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_contribuintesindividuais'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => $state.go('not_found', $stateParams));
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_contribuintesindividuais', {
                url: '/solicitacoes/contribuintesindividuais',
                template: require('html-loader!./index/contribuintesindividuais.index.html'),
                controller: 'MeurhContribuintesIndividuaisIndexController',
                controllerAs: 'mrh_cntrbnts_ndvds_cntrllr'
            })
            .state('meurh_contribuintesindividuais_new', {
                url: '/solicitacoes/contribuintesindividuais/new',
                template: require('html-loader!./new/contribuintesindividuais.new.html'),
                controller: 'MeurhContribuintesIndividuaisNewController',
                controllerAs: 'mrh_cntrbnts_ndvds_nw_cntrllr'
            })
            .state('meurh_contribuintesindividuais_show', {
                url: '/solicitacoes/contribuintesindividuais/show/{solicitacao}?path',
                template: require('html-loader!./show/contribuintesindividuais.show.html'),
                resolve,
                controller: 'MeurhContribuintesIndividuaisShowController',
                controllerAs: 'mrh_cntrbnts_ndvds_shw_cntrllr'
            });
    }
];
